module.exports = __webpack_public_path__ + "img/loading_wayi.92aba68a.gif";